<template>
  <div
    class="container-fluid"
    style="padding-top: 90px; padding-bottom: 90px"
    id="2"
    ref="some"
  >
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
          <h3 class="pl-3" style="font-weight: bold">{{ $t("about") }}</h3>
          <p class="pl-3">
           {{ $t("aboutp1") }}
          </p>
          <p class="pl-3">
            {{ $t("aboutp2") }}         
          </p>
          <p class="pl-3">
            {{ $t("aboutp3") }}
          </p>
          <p class="pl-3">
            {{ $t("aboutp4") }}
          </p>
        </div>
        <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
          <img src="@/assets/about.jpg" class="col" style="" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {};
  },
  async mounted() {},

  methods: {},

  components: {},
  props: {},

  computed: {},
};
</script>

<style scoped>
.pad {
  /* padding: 15px;  */
  /* height: 200px; */
  line-height: 120px;
  /* font-weight: 550; */
}
</style>
